import React, { useEffect, useState } from "react";
// import LoaderAnimation from '../patterns/atoms/LoaderAnimation';

export default function Quickview(props) {
    const initialIndex = props?.initialIndex || 0;

    const [quickview, setQuickview] = useState(false);
    const [quickviews, setQuickviews] = useState([]);

    let children = (props.children?.length >= 0 ? props.children : [props.children]).filter((o) => o !== false);

    useEffect(() => {
        const parsedViews = children.map((o) => {
            if (o?.props.quickview && o?.props.quickview?.identifier && o?.props.quickview?.name) {
                return o.props.quickview;
            }
        });
        setQuickviews(parsedViews);
        setQuickview(parsedViews[initialIndex].identifier);
    }, []);

    // if(!quickview) {
    //     return <LoaderAnimation/>;
    // }

    const currentQuickview = quickviews.find((o) => o?.identifier === quickview);

    return (
        <>
            {children
                .filter((o) => o.props?.quickview?.identifier === currentQuickview?.identifier)
                .map((child, childIdx) => {
                    return React.cloneElement(child, {
                        key: childIdx,
                        quickview: {
                            ...child.props.quickview,
                            quickviews,
                            quickview,
                            setQuickview
                        }
                    });
                })}
        </>
    );
}
